<template>
  <div class="home_category productDetailCommentTab">
    <div class="sub_heading flx">
      <h4>
        <span v-if="comments.length > 0">{{comments.length}}</span>
        {{$t('comments')}}
      </h4>
      <router-link
        :to="{path: '/product-comment/'+ saleReferenceId }"
        tag="span"
        class="see_all"
      >{{$t('writeComments')}}</router-link>
    </div>
    <ul class="product_comment" v-if="comments.length > 0">
      <li v-for="(comment,index) in comments.slice(0, 10)" :key="index">
        <div class="user_detail">
          <div class="user_img" @click="openUserProfile(comment.xAuthId)">
            <img src="../../assets/images/dummy.png" class="wdth100" alt="dummy" />
          </div>
          <div class="user_profile">
            <h3>{{comment.name}}</h3>
            <div class="time_stamp">{{comment.timeAgo}}</div>
            <span class="comment_text">{{comment.comment}}</span>
          </div>
        </div>
      </li>
    </ul>
    <router-link
      :to="{path: '/product-comment/'+ saleReferenceId }"
      tag="span"
      class="view_all_list"
      v-if="comments.length > 9"
    >{{$t('viewAllComments')}}</router-link>
    <ul class="product_comment" v-if="comments.length == 0">
      <li style="border-bottom : 0">Be the first to write something...</li>
    </ul>
  </div>
</template>

<script>
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
export default {
  name: "ProductDetailCommentTab",
  props: {
    CmtDetails: {
      required: true,
      type: Array
    },
    saleReferenceId: {
      type: String
    }
  },
  data() {
    return {
      comments: [],
      profileImage: null
    };
  },
  watch: {
    CmtDetails() {
      this.comments = this.CmtDetails;
    }
  },
  methods: {
    getUserInfo() {
      // let headers = {
      //   "x-auth-id": this.$cookie.get("X-Auth-Id")
      // };
      this.$store
        .dispatch({
          type: "payBoardUser"
        })
        .then(data => {
          this.profileImage = data.data.data.profileImageUrl;
          // console.log(data.data.data.profileImageUrl)
        });
    },
    openUserProfile(XAUTHID) {
      try {
        JSBridgePlugin.showNativeProfileView(XAUTHID);
      } catch (err) {
        console.log(err);
      }
    },
    writeNewComment() {}
  },
  mounted() {
    // this.getUserInfo();
    this.comments = this.CmtDetails;
  }
};
</script>